import { render, staticRenderFns } from "./NewsPostHeader.vue?vue&type=template&id=2f46a39e&"
import script from "./NewsPostHeader.vue?vue&type=script&lang=js&"
export * from "./NewsPostHeader.vue?vue&type=script&lang=js&"
import style0 from "./NewsPostHeader.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports